import React, { useState, useEffect, useRef } from "react";
import { ChevronDown, ChevronRight, Menu as MenuIcon, X as CloseIcon } from "lucide-react";

const menuItems = [
    {
        title: "Home",
        link: "/",

    },



    {
        title: "Partner",
        children: [

            { title: "Amazon ATES Partner", link: "/partner/amazon-ates-partner" },
            { title: "Amazon Affiliate Global Partner", link: "/partner/amazon-affiliate-global-partner" },
            { title: "Flipkart SPN Partner", link: "/partner/flipkart-spn-partner" },
            { title: "Jiomart Partner", link: "/partner/jiomart-partner" },
            { title: "Meesho Partner", link: "/partner/meesho-partner" },
        ],
    },
    {
        title: "Our Services",
        children: [
            {
                title: "Domestic Services",
                children: [
                    { title: "Amazon Account Management", link: "/domestic-services/amazon-account-management" },
                    { title: "Flipkart Account Management", link: "/domestic-services/flipkart-account-management" },
                    { title: "Meesho Account Management", link: "/domestic-services/meesho-account-management" },
                    { title: "Jiomart Account Management", link: "/domestic-services/jiomart-account" },
                    { title: "Purple Account Management", link: "/domestic-services/purple-account" },
                    { title: "Glow Road Account Management", link: "/domestic-services/glow-road" },
                    // { title: "Lime Road Account Management", link: "#" },
                ],
            },
            {
                title: " International Services",
                children: [
                    { title: "Amazon Global Account Management", link: "/international-services/amazon-global" },
                    { title: "Ebay Account Management", link: "/international-services/ebay" },
                    { title: "Etsy Account Management", link: "/international-services/etsy" },
                    { title: "Walmart Account Management", link: "/international-services/walmart" },
                    { title: "Alibaba Account Management", link: "/international-services/alibaba" },
                ],
            },
             {
                title: " FBA Services",
                children: [
                    { title: "FBA Shipment & Operation Support", link: "/fba-services/fba-shipment" },
                ],
            },
            {
                title: "Listing/Cataloging",
                children: [
                    { title: "Amazon Listing Services", link: "/listing-services/amazon" },
                    { title: "Flipkart Listing Services", link: "/listing-services/flipkart" },
                    { title: "Meesho Listing Services", link: "/listing-services/meesho" },
                    { title: "Jiomart Listing Services", link: "/listing-services/jiomart" },
                    { title: "Etsy Listing Services", link: "/listing-services/etsy" },
                    { title: "Walmart Listing Services", link: "/listing-services/walmart" },
                    { title: "Purple Listing Services", link: "/listing-services/purple" },
                    { title: "Glow Road Listing Services", link: "/listing-services/glow-road" },
                ],
            },
            {
                title: "Advertisement/Marketing",
                children: [
                    { title: "Amazon Advertisement Services", link: "/advertisement-services/amazon" },
                    { title: "Flipkart Advertisement Services", link: "/advertisement-services/flipkart" },
                    { title: "Meesho Advertisement Services", link: "/advertisement-services/meesho" },
                    { title: "Amazon Global Advertisement Services", link: "/advertisement-services/amazonglobal" },
                    { title: "Ebay Advertisement Services", link: "/advertisement-services/ebay" },
                ],
            },
            {
                title: "  Sales Boost/Rating & Reviews",
                children: [
                    { title: "Amazon Sales Boost Services", link: "/sales-services/amazon" },
                    { title: "Flipkart Sales Boost Services", link: "/sales-services/flipkart" },
                    { title: "Meesho Sales Boost Services", link: "/sales-services/meesho" },
                    { title: "Jiomart Sales Boost Services", link: "/sales-services/jiomart" },
                    { title: "Shopify Sales Boost Services", link: "/sales-services/shopify" },
                    { title: "Etsy Sales Boost Services", link: "/sales-services/etsy" },
                    { title: "Walmart Sales Boost Services", link: "/sales-services/walmart" },
                ],
            },
            {
                title: "Training Ecommerce",
                link: "/services/training",
            },
            {
                title: "  Digital Marketing",
                children: [
                    { title: "SMO Marketing", link: "/marketing-services/smo" },
                    { title: "SEO", link: "/marketing-services/seo" },
                    { title: "E-Mail Marketing", link: "/marketing-services/email" },
                    { title: "SEM Marketing", link: "/marketing-services/sem" },
                    { title: "SMM Marketing", link: "/marketing-services/smm" },
                    { title: "Affiliate Marketing", link: "/marketing-services/affliate" },
                ],
            },
            {
                title: "Product photoshoot/Videography",
                link: "/services/photoshoot",
            },
        ],
    },
    {
        title: "Calculator",
        link: "/calculator",
    },
    {
        title: " Free Onboarding",
        children: [
            { title: "Amazon Registration", link: "/registration-services/amazon" },
            { title: "Amazon Global Registration", link: "/registration-services/amazon-global" },
            { title: "Meesho Registration", link: "/registration-services/meesho" },
            { title: "Jiomart Registration", link: "/registration-services/jiomart" },
            { title: "Flipkart Registration", link: "/registration-services/flipkart" },
            { title: "Glow Road Registration", link: "/registration-services/glowroad" },
        ],
    },
    {
        title: "Blog",
        link: "/blog",
    },
    {
        title: "Contact Us",
        link: "/contact",
    },
    {
        title: "Career",
        link: "/career",
    },
    {
        title: "Events",
        link: "/career",
    },
    {
        title: "About Us",
        link: "/abouts",
    },

];

const MenuItem = ({ item, level = 0, activePath, setActivePath, parentPath = "" }) => {
    const hasChildren = item.children && item.children.length > 0;
    const currentPath = parentPath + item.title;
    const isTopLevel = level === 0;
    const isOpen = activePath[level] === currentPath;

    const toggleOpen = (e) => {
        e.stopPropagation();
        setActivePath((prev) => {
            const newPath = [...prev.slice(0, level), currentPath];
            return prev[level] === currentPath ? prev.slice(0, level) : newPath;
        });
    };

    return (
        <li className={`relative pl-${level * 4}`} >
            <div
                className="flex  items-center justify-between px-2 py-2 hover:bg-gray-200 cursor-pointer transition-all duration-200 rounded-md md:hidden"
                onClick={toggleOpen}
            >
                <a href={item.link} className={`text-gray-800 ${level === 0 ? "font-bold" : "font-normal"}`}>{item.title}</a>
                {hasChildren && (
                    <span className="ml-2">
                        {isOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
                    </span>
                )}
            </div>
            {hasChildren && isOpen && (
                <ul className="ml-4 mt-1 transition-all duration-200">
                    {item.children.map((child, idx) => (
                        <MenuItem
                            key={idx}
                            item={child}
                            level={level + 1}
                            activePath={activePath}
                            setActivePath={setActivePath}
                            parentPath={currentPath + "/"}
                        />
                    ))}
                </ul>
            )}
        </li>
    );
};

const Menu = () => {
    const [activePath, setActivePath] = useState([]);
    const [isSidebarOpen, setSidebarOpen] = useState(false);
    const sidebarRef = useRef(null);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 768) {
                setSidebarOpen(false);
            }
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                window.innerWidth < 768 &&
                sidebarRef.current &&
                !sidebarRef.current.contains(e.target)
            ) {
                setActivePath([]);
                setSidebarOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <>
            {/* Mobile Toggle Button */}
            <button
                className="md:hidden fixed top-4 right-4 z-50 p-2 bg-gray-200 rounded"
                onClick={() => setSidebarOpen(!isSidebarOpen)}
            >
                {isSidebarOpen ? <CloseIcon /> : <MenuIcon />}
            </button>

            {/* Sidebar */}
            <aside
                ref={sidebarRef}
                className={`bg-gray-100 shadow-lg w-64 h-screen p-2 overflow-auto m-0 fixed md:static top-0 left-0 z-40 md:hidden transition-transform duration-300 transform ${isSidebarOpen ? "translate-x-0" : "-translate-x-full md:translate-x-0"
                    }`}
            >
                <ul className="space-y-2">
                    {menuItems.map((item, index) => (
                        <MenuItem
                            key={index}
                            item={item}
                            link={item.link}
                            activePath={activePath}
                            setActivePath={setActivePath}
                        />
                    ))}
                </ul>
            </aside>
        </>
    );
};

export default Menu;
